const STYLES = {
  Active: "text-emerald-700 bg-emerald-50 border-emerald-200",
  Pending: "text-amber-700 bg-amber-50 border-amber-200",
  Suspended: "text-red-700 bg-red-50 border-red-200",
  Inactive: "text-slate-600 bg-slate-100 border-slate-200",
};

export function StatusBadge({ status }) {
  const cls = STYLES[status] || STYLES.Inactive;
  return (
    <span
      data-testid={`status-badge-${status?.toLowerCase()}`}
      className={`inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 text-xs font-semibold ${cls}`}
    >
      <span className="h-1.5 w-1.5 rounded-full bg-current opacity-70" />
      {status}
    </span>
  );
}
